export const CONTRATO_LABELS = {
  // Navigation
  administration: 'Administración',
  contratos: 'Contratos',

  // Actions
  createContrato: 'Crear Contrato',
  editContrato: 'Editar Contrato',
  save: 'Guardar',
  cancel: 'Cancelar',
  close: 'Cerrar',

  // Form fields
  numeroContratoId: 'ID de Contrato',
  numeroContrato: 'Número de Contrato',
  anioContrato: 'Año del Contrato',
  tipoContratoId: 'Tipo de Contrato',
  perfilId: 'Perfil',
  valorHonorariosMes: 'Valor Honorarios por Mes',
  beneficiario: 'Beneficiario',

  // Table
  tableId: 'ID',
  tableNumeroContrato: 'Número',
  tableAnioContrato: 'Año',
  tableTipoContrato: 'Tipo de Contrato',
  tablePerfil: 'Perfil',
  tableValorHonorarios: 'Valor Honorarios',
  tableBeneficiario: 'Beneficiario',
  tableActions: 'Acciones',

  // Messages
  loadingContratos: 'Cargando contratos...',
  noContratos: 'No hay contratos disponibles',

  // Tooltips
  tooltipEdit: 'Editar contrato',
  tooltipDelete: 'Eliminar contrato'
} as const;
